import { render, staticRenderFns } from "./BarrageGame.vue?vue&type=template&id=f211e9ec&scoped=true"
import script from "./BarrageGame.vue?vue&type=script&lang=js"
export * from "./BarrageGame.vue?vue&type=script&lang=js"
import style0 from "./BarrageGame.vue?vue&type=style&index=0&id=f211e9ec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f211e9ec",
  null
  
)

export default component.exports